import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { useAuth } from "./authContext";


// export const doCreateUserWithEmailAndPassword = async (email, password, myValue, name) => {
//   return  createUserWithEmailAndPassword(auth, email, password, name)
  
//   .then  ((result) => {
//      setDoc(doc(db, "users", auth.currentUser.uid), {
//       email, 
//       name
      
//     });
//     })
//     .catch((error) => {
//         console.log(error)
 
// });;
// };

// export const doCreateUserWithEmailAndPassword = async (email, password, myValue, name) => {
//   return createUserWithEmailAndPassword(auth, email, password, myValue, name)
//   .then((result) => {
//     setDoc(doc(db, "users", auth.currentUser.uid), {
//       email, 
//       "role": myValue,
//       name,
//       accessToken: 1
//     });
//     })
//     .catch((error) => {
//         console.log(error)
 
// });;
// };

export const doCreateUserWithEmailAndPassword = async (
  email,
  password,
  role,
  name,
  accessToken,
  totalSearches,
  marketResearchSearches,
  previousStudent
) => {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    const uid = result.user.uid;

    // Store user details in Firestore
    await setDoc(doc(db, 'users', uid), {
      email,
      role,
      name,
      accessToken,
      totalSearches,
      marketResearchSearches,
      previousStudent
    });

    // Optionally, add to GoHighLevel or other services
    await fetch('https://rest.gohighlevel.com/v1/contacts/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2NhdGlvbl9pZCI6IjhNeFBFdjJkZGE4SmlrYWVDUzBVIiwidmVyc2lvbiI6MSwiaWF0IjoxNzM3NDE4MDg5NTg0LCJzdWIiOiJHQXg5WUFndkpub2xzZ3laQzNmRyJ9.wvWWz0r5cjs_c-W9lvN0-fj62zkvUefScyu8GllesNM',        Version: '2021-07-28'
      },
      body: JSON.stringify({
        email,
        firstName: name,
        tags: ['app user'],
        locationId: '8MxPEv2dda8JikaeCS0U'
      })
    });

    console.log("User successfully added with custom access data.");

    return result;
  } catch (error) {
    console.error('Error creating user or adding to Firestore:', error);
    throw error;
  }
};

export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password)

};

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;

  // add user to firestore
};

export const doSignOut = () => {
  return auth.signOut().then(window.location = 'sign-in');
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};
